import axios from 'axios';

axios.defaults.withCredentials = true;
// Old bearer tokens are intentionally invalid after this security migration.
for (const key of ['adeeb-token', 'adeeb-admin-token']) {
  const value = localStorage.getItem(key);
  if (value && value !== 'cookie-session') {
    try { if (!Number.isInteger(JSON.parse(atob(value.split('.')[1])).sv)) localStorage.removeItem(key); }
    catch { localStorage.removeItem(key); }
  }
}

axios.interceptors.request.use((config) => {
  const target = new URL(config.url || '', config.baseURL || window.location.origin);
  if (target.origin !== window.location.origin) {
    delete config.headers.Authorization; delete config.headers['X-Admin-Token']; delete config.headers['X-Profile-Id']; config.withCredentials = false; return config;
  }
  const token = localStorage.getItem('adeeb-token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const code = err?.response?.data?.code;
    if (err?.response?.status === 403 && code === 'EMAIL_UNVERIFIED') {
      if (window.location.pathname !== '/verify-pending') {
        window.location.assign('/verify-pending');
      }
    }
    return Promise.reject(err);
  }
);
